<template>
	<main-layout>
		<section class="section">
			<div class="container">
				<slot name="top" />

				<div class="columns is-variable is-four-fifths">
					<div class="column">
						<slot />
					</div>
					<div class="column is-one-fifth is-hidden-touch"><slot name="sidebar" /></div>
				</div>
			</div>
		</section>
	</main-layout>
</template>
<script lang="ts" setup>
import MainLayout from "../layouts/MainLayout.vue";
</script>
